// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.client.dto.renter.RenterRequestPaymentStatus

export enum RenterRequestPaymentStatus {
  LANDLORD_ACCEPTED = 'LANDLORD_ACCEPTED',
  LANDLORD_REJECTED = 'LANDLORD_REJECTED',
  RENTER_OPTED_IN = 'RENTER_OPTED_IN',
  RENTER_OPTED_OUT = 'RENTER_OPTED_OUT',
}

export const RenterRequestPaymentStatus_values = [
  RenterRequestPaymentStatus.LANDLORD_ACCEPTED,
  RenterRequestPaymentStatus.LANDLORD_REJECTED,
  RenterRequestPaymentStatus.RENTER_OPTED_IN,
  RenterRequestPaymentStatus.RENTER_OPTED_OUT,
] as const;
